module.exports = __webpack_public_path__ + "static/attribution-fraud-nav-icon-a6b1bf64dc4295beca61c0f33d492630.svg";